<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.33333 13H11.6667C12.403 13 13 12.403 13 11.6667V2.33333C13 1.59695 12.403 1 11.6667 1H2.33333C1.59695 1 1 1.59695 1 2.33333V11.6667C1 12.403 1.59695 13 2.33333 13ZM2.33333 13L9.66667 5.66667L13 9M5.66667 4.66667C5.66667 5.21895 5.21895 5.66667 4.66667 5.66667C4.11438 5.66667 3.66667 5.21895 3.66667 4.66667C3.66667 4.11438 4.11438 3.66667 4.66667 3.66667C5.21895 3.66667 5.66667 4.11438 5.66667 4.66667Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
